import {
	bannerHeaderModuleDescriptionLenses,
} from 'root/src/client/logic/header/lenses'

const { viewNotified } = bannerHeaderModuleDescriptionLenses

export default viewNotified
